
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-c-5-v-kh-ty-fvp-9-oz-ldntidsy-9-w.json") })
        }
      }, "path---projects-c-5-v-kh-ty-fvp-9-oz-ldntidsy-9-w");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-c-5-v-kh-ty-fvp-9-oz-ldntidsy-9-w!./.cache/json/projects-c-5-v-kh-ty-fvp-9-oz-ldntidsy-9-w.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-c-5-v-kh-ty-fvp-9-oz-ldntidsy-9-w!./.cache/json/projects-c-5-v-kh-ty-fvp-9-oz-ldntidsy-9-w.json
// module chunks = 15178676390636814000